var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash',{attrs:{"icon":"fa fa-dollar","titulo":"PAGAMENTOS DESPESA","subTitulo":"FINALIZAÇÃO","qtd":_vm.qtd,"mostrarQtd":true,"loading":_vm.loading},nativeOn:{"click":function($event){return _vm.$router.push({ name: 'DespesasGerais_Finalizacao_Pagamentos' })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }